// First-party, first-touch lead attribution. Captured once on the visitor's
// first landing and persisted in localStorage through the whole flow.
const KEY = "belov_attribution_v1";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

export function captureAttribution() {
  try {
    if (localStorage.getItem(KEY)) return; // first-touch only
    const params = new URLSearchParams(window.location.search);
    const data = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) data[k] = v;
    });
    data.initial_referrer = document.referrer || "";
    data.initial_landing_page = window.location.pathname + window.location.search;
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) {
    /* localStorage unavailable — ignore */
  }
}

export function getAttribution() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}
